import type { PGD } from "../types";

export const pgdPenvSinusitis: PGD = {
  id: "pgd-6c-penv-sinusitis",
  reference: "6c",
  version: "1.0",
  drugRef: "phenoxymethylpenicillin",
  indication: "Acute sinusitis — no penicillin allergy",
  validFrom: "2024-01-31",
  expiryDate: "2027-01-30",
  frameworkType: "pharmacy_first",
  population: {
    ageRange: { min: 12, max: 999 },
    pregnancyAllowed: true,
    breastfeedingAllowed: true,
    notes: "Only 250mg tablets exist — no 500mg tablet. 500mg dose requires two 250mg tablets.",
  },
  duration: { days: 5 },
  doseBands: [
    {
      id: "penv-sinusitis-age12plus",
      resolveBy: "single",
      ageRange: { min: 12, max: 999 },
      dose: 500,
      frequency: "FOUR times a day",
      comment: "500mg dose uses TWO 250mg tablets — no 500mg tablet exists",
      formulations: [
        {
          formulationId: "penv-250-tab",
          instruction: "Take TWO 250mg tablets FOUR times a day for 5 days",
          quantity: { count: 40, label: "40 tablets" },
        },
        {
          formulationId: "penv-250-5ml",
          instruction: "Take 10mL (500mg) FOUR times a day for 5 days",
          quantity: { bottles: 2, label: "2 × 100mL bottles" },
        },
        {
          formulationId: "penv-125-5ml",
          instruction: "Take 20mL (500mg) FOUR times a day for 5 days",
          quantity: { bottles: 4, label: "4 × 100mL bottles" },
        },
      ],
    },
  ],
  preSupplyChecks: [
    { id: "ex-long-term-penv", question: "Currently on long-term phenoxymethylpenicillin?", hint: "e.g. prophylaxis in asplenia" },
    { id: "ex-ckd-severe", question: "CKD stage 4 or 5 (eGFR <30 mL/min/1.73m²)?" },
    { id: "ex-typhoid", question: "Oral typhoid vaccine within ±3 days?" },
    { id: "int-methotrexate", question: "Currently taking methotrexate?" },
    { id: "int-probenecid", question: "Currently taking probenecid?" },
    { id: "int-agranulocytosis", question: "Taking agranulocytosis-risk medicines?", hint: "methotrexate, sulfasalazine, carbimazole, propylthiouracil, cotrimoxazole, valganciclovir, clozapine, carbamazepine, chemotherapy" },
  ],
  cautions: [
    { id: "caution-breastfeeding", text: "Breastfeeding — monitor nursing infant for GI disturbances, nausea, hypersensitivity, rashes, oral candida infection." },
    { id: "caution-warfarin", text: "Coumarin anticoagulants — INR may rise. Advise INR monitoring and to seek medical attention if bleeding develops." },
    { id: "caution-excipients", text: "Check excipients: lactose, sucrose, fructose, sorbitol; aspartame in phenylketonuria." },
  ],
  counselling: [
    "Take on an empty stomach — 30 minutes before food or 2 hours after food",
    "Tablets should be swallowed whole",
    "Complete the full 5-day course even if symptoms improve",
    "Return to pharmacy if symptoms worsen rapidly or significantly at any time",
  ],
  counsellingPoints: [
    { text: "Take on an empty stomach — 30 minutes before food or 2 hours after food" },
    { text: "Tablets should be swallowed whole" },
    { text: "Complete the full 5-day course even if symptoms improve" },
    { text: "Return to pharmacy if symptoms worsen rapidly or significantly at any time" },
  ],
  outcomeLinkRefs: ["target-rti-leaflet", "nhs-sinusitis"],
};
